import { NIssue } from 'SharedDir/declarations/issue';
import { NPublicServices } from 'SharedDir/declarations/public-service';
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { publicServicesUrl, PUBLIC_SERVICES } from 'SharedDir/backend/endpoints/public-service';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

export default class PublicServicesApiClass extends SimpleApi<
  NPublicServices.Service,
  NPublicServices.Service
> {
  constructor() {
    super(publicServicesUrl);
  }

  /**
   * Получить подробную информацию о услуге
   *
   * @param serviceId
   * @returns
   */
  async getAboutService(serviceId: number): Promise<NPublicServices.ServiceAbout> {
    const { data } = (await http({
      ...PUBLIC_SERVICES.ABOUT(serviceId),
    })) as AxiosResponse<NPublicServices.ServiceAbout>;

    return data;
  }
}
